// Module
var code = "<ul> <li>Obtain loan information on your behalf, via phone or email</li> <li>Request us to mail or fax information regarding your loan account</li> <li>Provide us with your updated contact information</li> </ul> ";
// Exports
export default code;